<template>
  <div>
    <div class="type-title">{{ skillInfo.freeMarket ? '技能檔案' : '等級和介紹' }}</div>
    <div class="apply-info"><button :class="canReapply && 'can-reapply'" @click="canReapply && editSkill()">{{ canReapply ? '重新編輯' : '審核中' }}</button></div>
    <div class="apply-container">
      <div class="skill-level">{{ skillInfo.freeMarket ? skillInfo.gameName : skillInfo.gameLevelString }}</div>
      <div class="skill-images">
        <div :style="`width: ${ (300 + 12) * skillInfo.screenshotImageUrlList.length - 12}px`">
          <div
            v-for="(url, i) in skillInfo.screenshotImageUrlList"
            :key="'image-' + i"
            class="skill-img" :style="{ backgroundImage: `url('${ url }')` }"
          />
        </div>
      </div>
      <!-- <div class="line" /> -->
      <div class="info-title">自我介紹</div>
      <div class="skill-desc">{{ skillInfo.description }}</div>
      <div class="info-title">語音介紹</div>
      <fps-voice
        class="voice-wrap"
        :src="skillInfo.voiceUrl"
        :control="true"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    skillInfo: Object,
    gameInfo: Object,
  },
  computed: {
    canReapply() {
      return !this.skillInfo.recheckFlag
    },
  },
  methods: {
    editSkill() {
      this.$router.push({
        path: '/settled',
        query: {
          type: 'reapply',
          id: this.skillInfo.id,
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .type-title {
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    color: $color-gray-1;
    margin-top: 30px;
  }
  .apply-info {
    font-size: 14px;
    line-height: 20px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 20px;
    button {
      color: $color-orange;
    }
    .can-reapply {
      color: $color-link ;
    }
  }
  .apply-container {
    background: $color-light;
    border-radius: 8px;
    margin-top: 10px;
    padding: 20px 20px 40px;
    text-align: left;
    font-size: 14px;
    line-height: 20px;
    color: $color-gray-1;
    border: 1px solid $color-split;
    &>div {
      margin: 0 36px;
    }
    .info-title {
      font-weight: 500;
      margin-top: 30px;
    }
    .skill-level {
      margin-bottom: 20px;
    }
    .skill-images {
      height: 168px;
      overflow-x: auto;
      @include hideScrollBar;
      &>div {
        display: flex;
        height: 100%;
      }
    }
    .skill-img {
      width: 300px;
      height: 100%;
      border-radius: 10px;
      background: #B3B3B3 no-repeat center center / auto 100%;
      margin-left: 12px;
      &:first-child {
        margin-left: 0;
      }
    }
    .line {
      height: 1PX;
      background: #F4F6F7;
      margin: 60px 0 0;
    }
    .skill-desc {
      margin-top: 15px;
      color: $color-gray-2;
    }
    .voice-wrap {
      width: 120px;
      height: 38px;
      margin-top: 15px;
    }
  }
</style>
